<template>
    <div class="news-thumb-wrap">
        <div
            class="news-img"
            :style="'background-image: url(' + newsImage + ')'"
        >
            <router-link
                :to="{
                    name: 'NewsDetails',
                    params: { postId: news.id },
                }"
            >
                <div class="overlay" :class="overlayColor(index)">
                    <h4 class="news-title">
                        {{ JSONParseTranslations(news.title, locale.key) }}
                    </h4>
                </div>
            </router-link>
        </div>

        <div class="news-summary">
            <div class="row q-mb-sm text-bold text-caption text-grey">
                {{ $t('general.published_date') }}:
                {{ formatDate(news.start_date) }}
            </div>

            <div v-html="JSONParseTranslations(news.summary, locale.key)"></div>
        </div>

        <q-btn
            class="view-btn"
            icon="visibility"
            color="primary"
            text-color="grey-8"
            size="16px"
            flat
            dense
            :to="{
                name: 'NewsDetails',
                params: { postId: news.id },
            }"
        >
            <span class="hidden-text">{{ $t('general.read_more') }}</span>
        </q-btn>
    </div>
</template>

<script>
import formatDate from '@/helpers/date-time'
import encoders from '@/helpers/encoders'
import translate from '@/local-shared/mixins/translate'
import picturesService from '@/services/pictures'
import store from '@/store'

export default {
    name: 'PostThumb',

    mixins: [translate],

    props: {
        index: {
            type: Number,
            default: 0,
        },

        news: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            newsImage: '',
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    async created() {
        if (this.news.picture_id) {
            this.newsImage = await this.fetchImage(this.news.picture_id)
        } else {
            this.newsImage = require('@/assets/logo.svg')
        }
    },

    methods: {
        overlayColor(index) {
            return 'overlay-color-' + (index % 3)
        },

        dateMaskFormat() {
            return this.locale &&
                this.locale.definition &&
                this.locale.definition.dateFormat
                ? this.locale.definition.dateFormat
                : 'DD/MM/YYYY'
        },

        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(
                      value,
                      'date',
                      this.dateMaskFormat()
                  )
                : null
        },

        async fetchImage(pictureId) {
            let imageResponse = await picturesService.retrieveById(pictureId)

            if (imageResponse.status === 200) {
                return encoders.arrayBufferToBase64(imageResponse)
            } else {
                return '' //TODO: add a default image
            }
        },
    },
}
</script>
